<template>
    <v-card>
        <v-layout>
            <v-flex xs12 v-if="!loading && loadError" class="notPrinted">
                <v-alert outline :value="true" color="error" icon="error">
                    {{loadError}}
                </v-alert>
            </v-flex>
            <v-flex xs12 v-if="!loadError" class="notPrinted">
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Supplier Order Listing</h1>
                    </v-flex>
                </v-layout>
                <v-form v-model="searchFormValid" ref="form">
                    <v-layout wrap>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-autocomplete
                                :items="stores"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.storeIDs"
                                multiple
                                label="Stores"
                                hint="Stores"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-autocomplete
                                :items="departments"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.departmentIDs"
                                multiple
                                label="Departments"
                                hint="Departments"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-autocomplete
                                :items="suppliers"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.supplierID"
                                label="Supplier"
                                hint="Supplier"
                                :rules="[rules.selectIDRequired]"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="startDatePickerMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="search.minDate"
                                    label="Start Date"
                                    prepend-icon="event"
                                    hint="Start Date"
                                    readonly
                                ></v-text-field>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="search.minDate"
                                    @input="startDatePickerMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="endDatePickerMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="search.maxDate"
                                    label="End Date"
                                    prepend-icon="event"
                                    hint="End Date"
                                    readonly
                                ></v-text-field>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="search.maxDate"
                                    @input="endDatePickerMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm5 offset-sm3>
                            <v-btn block color="success" :disabled="!searchFormValid" :loading="ordersLoading" @click="loadOrders">Search</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="orders"
                            :loading="loading"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                            :total-items="totalOrders"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID" @click="props.expanded = !props.expanded">
                                    <td>{{props.item.ID}}</td>
                                    <td>{{props.item.StoreName}}</td>
                                    <td>{{props.item.DepartmentName}}</td>
                                    <td>{{props.item.SupplierName}}</td>
                                    <td>{{props.item.TotalQuantity}}</td>
                                    <td>{{formatCurrency(props.item.TotalCost)}}</td>
                                    <td>
                                        <v-btn
                                            color="info"
                                            block
                                            @click="viewDetails(props.item)"
                                        >
                                            View Details
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>




            <v-dialog v-model="showViewDetailsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="cancelViewDetailsOrder">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Order Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="detailsData.OrderID"
                                            :readonly="true"
                                            label="Order ID">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="viewDetailsOrderDate"
                                            :readonly="true"
                                            label="Order Date">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="detailsData.StoreName"
                                            :readonly="true"
                                            label="Store">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="detailsData.DepartmentName"
                                            :readonly="true"
                                            label="Department">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="detailsData.SupplierName"
                                            :readonly="true"
                                            label="Supplier">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-data-table
                                            :headers="viewDetailsHeaders"
                                            :items="detailsData.Products"
                                            :loading="viewDetailsDialogLoading"
                                            hide-actions
                                            must-sort
                                        >
                                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                            <template slot="items" slot-scope="props">
                                                <tr :data-id="props.item.ID" >
                                                    <td>{{props.item.ProductName}}</td>
                                                    <td>{{props.item.Quantity}}</td>
                                                    <td>{{formatCurrency(props.item.CostPrice)}}</td>
                                                    <td>{{formatCurrency(props.item.TotalCost)}}</td>
                                                </tr>
                                            </template>
                                            <template slot="footer">
                                                <tr class="body-2">
                                                    <td>Totals</td>
                                                    <td>{{detailsData.TotalQuantity}}</td>
                                                    <td></td>
                                                    <td>{{formatCurrency(detailsData.TotalCost)}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="!viewDetailsDialogLoading" slot="no-data">
                                                <v-alert v-if="detailsDialogError" outline :value="true" color="error" icon="error">
                                                    {{detailsDialogError}}
                                                </v-alert>
                                                <v-alert v-if="!detailsDialogError" outline :value="true" type="info">
                                                    No results found
                                                </v-alert>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>   
                                <v-layout wrap class="dialog-action-buttons notPrinted">
                                    <v-flex xs12 md6>
                                        <v-btn block color="info" @click="cancelViewDetailsOrder">Back</v-btn>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-btn block color="info" @click="triggerPrint">Print</v-btn>
                                    </v-flex>
                                </v-layout>                       
                            </v-flex>
                        </v-layout>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import formatters from "../../helpers/formatters";
import validationRules from "@/helpers/validationrules";
import auth from '@/services/auth';
import util from '@/services/util';
import Vue from 'vue'

export default {
    data() {
        return {
            searchFormValid: false,
            search: {
                storeIDs: [],
                startDate: null,
                endDate: null
            },
            rules: validationRules.rules,
            ordersLoading: false,
            orders: [],
            totalOrders: 0,
            rowsPerPage: [20, 50, 100],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "ID",
                descending: true
            },
            startDatePickerMenu: false,
            endDatePickerMenu: false,
            headers: [
                {
                    text: "Order Number",
                    value: "ID"
                },
                {
                    text: "Store",
                    value: "StoreName"
                },
                {
                    text: "Department",
                    value: "DepartmentName"
                },
                {
                    text: "Supplier",
                    value: "SupplierName"
                },
                {
                    text: "Total Quantity",
                    value: "TotalQuantity"
                },
                {
                    text: "Total Cost",
                    value: "TotalCost",
                    sortable: false
                },
                {
                    text: "", // view button
                    sortable: false
                }
            ],
            showViewDetailsDialog: false,
            viewDetailsDialogLoading: false,
            detailsDialogError: "",
            detailsData: {},
            viewDetailsHeaders: [
                {
                    text: "Product Name",
                    value: "ProductName"
                },
                {
                    text: "Quantity",
                    value: "Quantity"
                },
                {
                    text: "Cost Price",
                    value: "CostPrice"
                },
                {
                    text: "Total Cost",
                    value: "TotalCost"
                }
            ]
        }
    },
    watch: {
        pagination: {
            handler(a, x){
                if (a.page != x.page || a.rowsPerPage != x.rowsPerPage || a.sortBy != x.sortBy || a.descending != x.descending){
                    this.loadOrders();
                }
            },
            deep: true
        }
    },
    computed: {
        loading() {
            return this.ordersLoading
                || this.$store.state.storeStore.loading
                || this.$store.state.supplierStore.loading;
        },
        loadError() {
            return this.$store.state.reportStore.order.loadError;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active).sort(util.sortByName);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active).sort(util.sortByName);
        },
        suppliers(){
            return this.$store.state.supplierStore.suppliers.filter(c => c.Active);
        },
        viewDetailsOrderDate() {
            if (this.detailsData && this.detailsData.OrderDate){
                return this.formatDate(this.detailsData.OrderDate)
            } else {
                return "";
            }
        }
    },
    methods: {
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        },
        loadSuppliers() {
            this.$store.dispatch("supplierStore/loadSuppliers");
        },
        loadOrders() {
            if (this.$refs.form.validate() && this.search.supplierID && this.search.supplierID != null && this.search.supplierID > 0){
                this.ordersLoading = true;

                let that = this;
                this.$store.dispatch("reportStore/loadOrderSentReports", {
                    params: {
                        PaginationPage: this.pagination.page,
                        PaginationPageSize: this.pagination.rowsPerPage,
                        SortBy: this.pagination.sortBy,
                        SortDirection: this.pagination.descending ? "DESC" : "ASC",
                        SearchMinDate: this.search.minDate,
                        SearchMaxDate: this.search.maxDate,
                        SearchStoreIDs: JSON.stringify(this.search.storeIDs),
                        SearchDepartmentIDs: JSON.stringify(this.search.departmentIDs),
                        SearchSupplierID: this.search.supplierID ? this.search.supplierID : -1
                    },
                    success: (data) => {
                        console.log(data)
                        that.orders = data.Orders;
                        that.totalOrders = data.TotalOrders;
                    },
                    finally: () => {
                        that.ordersLoading = false;
                    }
                });
            }
        },
        allowedDates(val){
            return true;
        },
        clearOrderReports(){
            this.$store.dispatch("reportStore/clearOrderReports");
        },
        formatCurrency(value) {
            if(value == null){
                return;
            }

            return formatters.formatCurrency(value);
        },
        formatDate(value){
            if(value == null){
                return;
            }

            return formatters.formatDate(value);
        },
        viewDetails(item){
            var that = this;
            that.viewDetailsDialogLoading = true;
            that.showViewDetailsDialog = true;
            this.$store.dispatch("reportStore/loadDetailedOrderReport", {
                params: {
                    SupplierID: this.search.supplierID,
                    OrderID: item.ID
                },
                success: (data) => {
                    console.log(data)
                    that.detailsData = data;
                    that.detailsDialogError = "";
                },
                error: (e) => {
                    that.detailsDialogError = e;
                },
                finally: () => {
                    that.viewDetailsDialogLoading = false;
                }
            });
        },
        cancelViewDetailsOrder() {
            this.showViewDetailsDialog = false;
            this.detailsData = {};
        },
        triggerPrint(){
            window.print();
        },
    },
    created() {
        this.loadStores();
        this.loadDepartments();
        this.loadSuppliers();

        if(!this.search){
            this.search = {};
        }

        if(!this.search.minDate){
            this.search.minDate = "";
        }

        if(!this.search.maxDate){
            this.search.maxDate = "";
        }

        if(!this.search.storeIDs){
            this.search.storeIDs = [];
        }

        if(!this.search.departmentIDs){
            this.search.departmentIDs = [];
        }

        if(!this.search.supplierID){
            this.search.supplierID = undefined;
        }
    }
}
</script>